import React, {Component} from 'react';
import {createRoot} from 'react-dom/client';
import {HashRouter, Route} from 'react-router-dom';
import {CookiesProvider} from 'react-cookie';
import {Provider} from 'react-redux';
import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';
import {QueryParamProvider} from 'use-query-params';

import ErrorBoundary from "./ErrorBoundary";
import AccountDetails from "./components/AccountDetails";
import EmailVerifyView from "./components/Auth/EmailVerifyView";
import ForgottenPassword from "./components/Auth/ForgottenPassword";
import LoginView from "./components/Auth/LoginView";
import ResetPassword from "./components/Auth/ResetPassword";
import SignUpView from "./components/Auth/SignUpView";
import SomethingWentWrong from "./components/ErrorComponents/500";
import GoogleAnalyticsTag from "./components/GoogleAnalyticsTag";
import Checkout from "./components/Pricing/Checkout";
import Pricing from "./components/Pricing/Pricing";
import RecommendationEditor from "./components/RecommendationEditor/RecommendationEditor";
import Workspace from "./components/Workspace";
import SelectionListener from "./components/Workspace/SelectionListener";
import WorkspaceSelectionPage from "./components/Workspace/WorkspaceSelection/WorkspaceSelectionPage";
import WorkspaceAdmin from "./components/WorkspaceAdmin";
import AuthenticatedRoute from "./components/util/components/AuthenticatedRoute";
import {DROPS} from "./components/util/featureFlags";
import CurrentMonitoredUri from "./components/CurrentMonitoredUri";
import AddUrl from "./components/AddRecommendations";

import BrokenLinks from "./components/BrokenLinks";
import ExportsPage from "./components/Exports/ExportsPage";
import TrendsDashboard from "./components/TrendsDashboard";
import Traffic from "./components/Traffic";
import Issues from "./components/Issues";
import IssueDeepDive from "./components/IssueDeepDive";
import Drops from "./components/Drops";
import RedirectsPage from "./components/RedirectsPage";
import AuditPage from "./components/AuditPage";
import SitemapPage from "./components/SitemapPage";

import AppLayout from "./components/Layout/AppLayout";
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import rootReducer from './reducers';

import {apiMiddlewares} from './reducers/rtkqReducers'; // ⬅ aggregated RTKQ middlewares

class App extends Component {
    render() {
        return (
            <HashRouter>
                <QueryParamProvider ReactRouterRoute={Route}>
                    <GoogleAnalyticsTag />

                    <AppLayout>
                        <ErrorBoundary>
                            <RecommendationEditor />

                            <AuthenticatedRoute exact path="/" component={WorkspaceSelectionPage} />
                            <AuthenticatedRoute exact path="/workspaces" component={WorkspaceSelectionPage} />

                            <AuthenticatedRoute path="/account/:section?" component={AccountDetails} />

                            <AuthenticatedRoute exact path="/change-subscription" component={Pricing} />
                            <Route exact path="/pricing" component={Pricing} />
                            <Route exact path="/checkout" component={Checkout} />

                            <Route exact path="/login" component={LoginView} />
                            <Route exact path="/register" component={SignUpView} />
                            <Route exact path="/email-verify" component={EmailVerifyView} />
                            <Route exact path="/forgotten-password" component={ForgottenPassword} />
                            <Route exact path="/reset-password" component={ResetPassword} />

                            <Route path="/error" component={SomethingWentWrong} />

<AuthenticatedRoute path="/ws/:workspaceNumber/monitored-uris/:id" component={CurrentMonitoredUri} />
                            <AuthenticatedRoute exact path="/ws/:workspaceNumber/trends" component={TrendsDashboard} />
                            <AuthenticatedRoute exact path="/ws/:workspaceNumber/traffic" component={Traffic} />
                            <AuthenticatedRoute exact path="/ws/:workspaceNumber/issues" component={Issues} />
                            <AuthenticatedRoute exact path="/ws/:workspaceNumber/issues/:id" component={IssueDeepDive} />
                            <AuthenticatedRoute exact path="/ws/:workspaceNumber/drops" featureFlag={DROPS} component={Drops} />
                            <AuthenticatedRoute exact path="/ws/:workspaceNumber/redirects" component={RedirectsPage} />
                            <AuthenticatedRoute exact path="/ws/:workspaceNumber/audit" component={AuditPage} />
                            <AuthenticatedRoute exact path="/ws/:workspaceNumber/sitemap" component={SitemapPage} />
<AuthenticatedRoute exact path="/ws/:workspaceNumber/broken-links" component={BrokenLinks} />
                            <AuthenticatedRoute exact path="/ws/:workspaceNumber/exports" component={ExportsPage} />
                            <AuthenticatedRoute exact path="/ws/:workspaceNumber/add-url" component={AddUrl} />
                            <AuthenticatedRoute exact path="/ws/:workspaceNumber/admin" component={WorkspaceAdmin} />

                            <Route path="/ws/:workspaceNumber" component={SelectionListener} />

                            <AuthenticatedRoute exact path="/ws/:workspaceNumber/" component={Workspace} />
                        </ErrorBoundary>
                    </AppLayout>
                </QueryParamProvider>
            </HashRouter>
        );
    }
}

const container = document.getElementById('root');
const root = createRoot(container);
const store = createStore(rootReducer, applyMiddleware(thunk, ...apiMiddlewares));

root.render(
    <Provider store={store}>
        <CookiesProvider>
            <App />
        </CookiesProvider>
    </Provider>
);
